<template>
  <div class="rb-pricing-details">
    <div class="rb-price-detail" v-if="diamondPrice">
      <div class="rb-price-title">Diamond Price</div>
      <div class="rb-price-value">{{ diamondPrice | money }}</div>
    </div>
    <div class="rb-price-detail">
      <div class="rb-price-title">Setting Price</div>
      <div class="rb-price-value">{{ baseRingPrice | money }}</div>
    </div>
    <div class="rb-price-detail rb-price-detail-total">
      <div class="rb-price-title">Total Ring Price</div>
      <div class="rb-price-value">{{ totalPrice | money }}</div>
    </div>
    <div class="rb-price-detail" v-if="withStockStatus">
      <stock-status-description />
    </div>
  </div>
</template>
<script>
/**
 * Displays total setting price
 *
 * @implements
 * FormattersMixin
 * CommMixin
 *
 * @props
 * prev: String
 * prevComplete: String
 *
 * @listens
 * rb-update-price
 *
 * @emits
 * rb-total-price-update
 *
 */
import FormattersMixin from "@/mixins/FormattersMixin";
import CommMixin from "@/mixins/CommMixin";
import StockStatusDescription from "@/components/StockStatusDescription";
import { formatMoney } from "../lib";
export default {
  mixins: [FormattersMixin, CommMixin],
  components: { StockStatusDescription },
  props: {
    withStockStatus: {
      type: Boolean,
      default: true,
    },
    messagePrev: {
      type: String,
      default: "",
    },
    messagePost: {
      type: String,
      default: "",
    },
    messagePrevComplete: {
      type: String,
      default: "",
    },
    combinePrice: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      baseRingPrice: 0,
      fromDiamondPrice: 0,
      diamondPrice: 0,
      additionalPrice: 0,
    };
  },
  computed: {
    priceMessage: function () {
      if (this.combinePrice) {
        return `${this.prevMessage} $${formatMoney(this.totalPrice)}`;
      } else {
        if (this.diamondPrice) {
          return `${this.prevMessage} $${formatMoney(this.totalPrice)}`;
        } else {
          return `$${formatMoney(this.baseRingPrice)} ${this.messagePost}`;
        }
      }
    },
    totalPrice: function () {
      var totalPrice =
        this.baseRingPrice +
        (this.diamondPrice ? this.diamondPrice : this.fromDiamondPrice) +
        this.additionalPrice;
      this.broadcast("rb-total-price-update", { totalPrice });
      return totalPrice;
    },
    prevMessage: function () {
      //return this.prev;
      // Uncomment this to re-enable the "from" model that disappears when diamond is selected
      return this.diamondPrice
        ? this.messagePrevComplete !== ""
          ? this.messagePrevComplete
          : ""
        : `${this.messagePrev} `;
    },
  },
  mounted: function () {
    this.initEvents();
  },
  methods: {
    initEvents: function () {
      this.subscribe("rb-update-price", this.onUpdatePrice);
    },
    onUpdatePrice: function (data) {
      this.updatePrice(data);
    },
    updatePrice: function (data) {
      // console.log("data price", data);
      this.baseRingPrice = data.baseRingPrice;
      this.diamondPrice = 0;
      this.fromDiamondPrice = data.fromDiamondPrice;
      this.additionalPrice = data.selectedOptions
        .filter((selectedOption) => selectedOption.choice.additionalPrice)
        .reduce(
          (total, option) => total + option.choice.additionalPrice / 100,
          0
        );
      var diamondPriceData = data.selectedOptions.find(
        (selectedOption) => selectedOption.step.id === "diamond"
      );
      if (diamondPriceData) {
        this.diamondPrice = parseInt(diamondPriceData.choice.retail_price);
      }
      // Get Additional Price (search for options with choices that have additional price)
    },
  },
};
</script>
